import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const CircleOutlinedIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M10 0.75C15.1086 0.75 19.25 4.89137 19.25 10C19.25 15.1086 15.1086 19.25 10 19.25C4.89137 19.25 0.75 15.1086 0.75 10C0.75 4.89137 4.89137 0.75 10 0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
  </SvgIcon>
);
